import type { MenuConfig } from '~typings/menu'

import permisosContabilidadPg, { RESOURCE_CONTABILIDAD_PG } from '@/auth/permissions/modules/contabilidadPg'
import * as names from '@routes/contabilidad-pg/nombres/configuracion'

const { configuracion } = permisosContabilidadPg
export default [
    {
        title: 'contabilidad.configuracion.diario_apertura.menu_title',
        route: names.ROUTE_DIARIO_APERTURA,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: configuracion.diarioApertura,
    },
    {
        title: 'contabilidad.configuracion.permisos.menu_title',
        route: names.ROUTE_PERMISOS_ADMINISTRACION,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: configuracion.permisosAdministracion,
    },
    {
        title: 'contabilidad.configuracion.permisos_transacciones.menu_title',
        route: names.ROUTE_PERMISOS_TRANSACCIONES,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: configuracion.permisosTransacciones,
    },
    {
        title: 'contabilidad.configuracion.plan_cuenta.menu_title',
        route: names.ROUTE_CREAR_PLAN_CUENTA,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: configuracion.planCuenta,
    },
    {
        title: 'contabilidad.configuracion.asignacion_permisos.menu_title',
        route: names.ROUTE_ASIGNACION_PERMISOS,
        resource: RESOURCE_CONTABILIDAD_PG,
        action: configuracion.asignacionPermisos,
    },
] as MenuConfig[]
